import { Routes } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { preventDuplicateLoginGuard, redirectUrlGuard, verificationGuard } from './core/auth/auth.guard';
import { ErrorComponent } from './pages/error/error.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { VerificationComponent } from './pages/verification/verification.component';
import { GoogleComponent } from './pages/auth/google/google.component';
import { SignOutComponent } from './pages/sign-out/sign-out.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ForgotPasswordSuccessComponent } from './pages/forgot-password/forgot-password-success/forgot-password-success.component';
import { PreventDuplicateLoginComponent } from './pages/prevent-duplicate-login/prevent-duplicate-login.component';
import { DeleteAccountComponent } from './pages/delete-account/delete-account.component';
import { ConfirmDeletionComponent } from './pages/confirm-deletion/confirm-deletion.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [redirectUrlGuard, preventDuplicateLoginGuard],
    component: LayoutComponent,

    children: [
      {
        path: '',
        redirectTo: 'sign-in',
        pathMatch: 'full',
      },
      {
        path: 'sign-in',
        component: SignInComponent,
      },
      {
        path: 'sign-up',
        component: SignUpComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'forgot-password-success',
        component: ForgotPasswordSuccessComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },
    ],
  },
  {
    path: '',
    canActivate: [redirectUrlGuard],
    component: LayoutComponent,
    children: [
      {
        path: 'sign-out',
        component: SignOutComponent,
      },
      {
        path: 'prevent-duplicate-login',
        component: PreventDuplicateLoginComponent,
      },
      {
        path: 'delete-account',
        component: DeleteAccountComponent,
      },
      {
        path: 'confirm-deletion',
        component: ConfirmDeletionComponent,
      },
    ],
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'google',
        component: GoogleComponent,
      },
    ],
  },
  {
    path: '',
    canActivate: [verificationGuard],
    component: LayoutComponent,
    children: [
      {
        path: 'verification',
        component: VerificationComponent,
      },
    ],
  },
  {
    path: '**',
    component: ErrorComponent,
  },
];
